var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRadar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 78.86 101",
    style: {
      enableBackground: "new 0 0 78.86 101"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000052084637362642321310000002342494489687375259_);}\r\n\t.st2{fill:url(#SVGID_00000145762161463541801450000014935968778271804086_);}\r\n\t.st3{fill:url(#SVGID_00000178898242030627388150000011341734184054663296_);}\r\n\t.st4{fill:url(#SVGID_00000065764745069025117110000006431676449006355585_);}\r\n\t.st5{fill:url(#SVGID_00000151525637008404620470000012355564416729955775_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.8359,
    y1: 50.4201,
    x2: 76.0895,
    y2: 80.0469
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9677,
    style: {
      stopColor: "#6773E9"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.31,64.88c-6.44-2.54-1.76-7.63,0.78-5.08c0.2,0.39,0.59,0.58,0.98,0.78c1.36,0.58,2.73,0.19,3.71-0.78 c2.53-2.35,7.22,2.54,0.78,5.08C40.61,65.85,38.26,65.85,36.31,64.88z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016047212155723745540000013838242804580745615_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.4501,
    y1: 57.1917,
    x2: 72.7037,
    y2: 86.8185
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9677,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016047212155723745540000013838242804580745615_)"
    },
    d: "M28.89,68c5.86,5.87,15.23,5.87,21.08,0 c2.15-2.15,5.47,1.18,3.32,3.32c-7.61,7.63-20.1,7.63-27.72,0C23.43,69.18,26.75,65.85,28.89,68z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141454647789914166200000016130100639236474501_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.0503,
    y1: 63.9914,
    x2: 69.3038,
    y2: 93.6182
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9677,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000141454647789914166200000016130100639236474501_)"
    },
    d: "M20.89,76.21 c10.15,10.16,26.94,10.16,37.09,0c2.34-2.15,5.46,0.98,3.32,3.32c-12.11,12.12-31.63,12.12-43.73,0 C15.42,77.19,18.55,74.06,20.89,76.21z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126291354564480555020000001962456219566230960_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.6961,
    y1: 70.6996,
    x2: 65.9497,
    y2: 100.3264
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9677,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126291354564480555020000001962456219566230960_)"
    },
    d: "M69.49,87.54 c-16.59,16.61-43.52,16.61-60.12,0c-2.14-2.15,1.18-5.47,3.32-3.32c14.84,14.85,38.65,14.85,53.48,0 C68.32,82.07,71.64,85.39,69.49,87.54z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180359889043744240650000003504051855967269776_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.6929,
    y1: -3.5826,
    x2: 78.7695,
    y2: 83.9198
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0581,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000180359889043744240650000003504051855967269776_)"
    },
    d: "M40.61,28.92c0.78,0.78,0.78,1.76,0,2.54 c-0.59,0.59-1.76,0.59-2.35,0C36.51,29.9,39.04,27.36,40.61,28.92z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162314583689634537850000016074266268752713910_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.3104,
    y1: -8.4285,
    x2: 85.3869,
    y2: 79.0739
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0581,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000162314583689634537850000016074266268752713910_)"
    },
    d: "M68.52,0H10.35C4.69,0,0,4.69,0,10.36 v11.92c0,5.66,4.69,10.36,10.35,10.36h14.64c0.98,6.44,6.25,10.94,12.1,11.91v10.56c0,3.12,4.69,3.12,4.69,0V44.75 c2.92-0.59,5.66-1.76,8-4.1c2.34-2.54,3.71-5.28,4.1-8.01h14.64c5.66,0,10.34-4.7,10.34-10.36V10.36C78.86,4.69,74.18,0,68.52,0z  M43.92,34.78c-4.1,4.11-10.93,1.18-10.93-4.49c0-3.71,2.93-6.45,6.44-6.45C45.09,23.84,48.02,30.68,43.92,34.78z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadar);
export default __webpack_public_path__ + "static/media/radar.303145905ab195a9197a4128a0de12ea.svg";
export { ForwardRef as ReactComponent };